export default __webpack_public_path__ + "static/media/vacasa-iso.47ca36f0.svg";